import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input, Textarea } from "formsy-react-components";
import autoBind from "react-autobind";

class RoleForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      canSubmit: false,
    };

    autoBind(this);
  }

  enableButton() {
    this.setState({
      canSubmit: true,
    });
  }

  disableButton() {
    this.setState({
      canSubmit: false,
    });
  }

  submit(model) {
    this.props.onSave(model);
    this.refs.form.reset();
  }

  resetForm() {
    this.refs.form.reset();
  }

  render() {
    return (
      <Formsy
        ref="form"
        className="vertical form"
        onValidSubmit={this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Col md={6}>
          <Input
            formNoValidate
            required
            name="name"
            label="Name"
            placeholder="Name"
            value={this.props.role.name || ""}
          />
        </Col>
        <Col md={6}>
          <Input
            formNoValidate
            required
            name="number"
            label="Number"
            placeholder="Number"
            value={this.props.role.number || ""}
          />
        </Col>
        <Col md={12}>
          <Link
            style={
              this.props.role.id != 0
                ? { display: "inline" }
                : { display: "none" }
            }
            className="btn btn-danger"
            to="/app/settings/roles"
          >
            Cancel
          </Link>
          <button
            className="btn btn-warning"
            type="button"
            onClick={this.resetForm}
          >
            Reset
          </button>
          <input
            className="btn btn-success"
            type="submit"
            disabled={!this.state.canSubmit}
            value={this.props.saving ? "Saving... " : "Save"}
          />
        </Col>
      </Formsy>
    );
  }
}

RoleForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  role: PropTypes.object.isRequired,
};

export default RoleForm;
